
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93mKhrQ6y8BgBFOXRa2iZG0xMgzNUkkOYvDnBX50FZsJIMeta } from "/usr/src/app/pages/[...slug].vue?macro=true";
import { default as indexQkfZdo6ZiMAGDgtzvRa1sZcdkd0247XFY9i8BP3Ps_45oMeta } from "/usr/src/app/pages/account/index.vue?macro=true";
import { default as _91_46_46_46slug_93y_xfecBbeGKcpoVQQ42MmTHKYqNGZHEEA7QAzG1igcAMeta } from "/usr/src/app/pages/cart/[...slug].vue?macro=true";
import { default as component_45stubLq50MOh9E_xuYW_z4dLccAG_41XK6rav1SlBAZqsQOsMeta } from "/usr/src/app/node_modules/.pnpm/nuxt@3.17.5_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@18.19.110_db0@0.3.2_eslint_t2ykcx5otu5g34mebxjltn3ldu/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubLq50MOh9E_xuYW_z4dLccAG_41XK6rav1SlBAZqsQOs } from "/usr/src/app/node_modules/.pnpm/nuxt@3.17.5_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@18.19.110_db0@0.3.2_eslint_t2ykcx5otu5g34mebxjltn3ldu/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "slug___de_AT",
    path: "/de_AT/:slug(.*)*",
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___de_DE",
    path: "/de_DE/:slug(.*)*",
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___de_CH",
    path: "/de_CH/:slug(.*)*",
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___fr_CH",
    path: "/fr_CH/:slug(.*)*",
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___en_GB",
    path: "/en_GB/:slug(.*)*",
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___en_US",
    path: "/en_US/:slug(.*)*",
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___fr_FR",
    path: "/fr_FR/:slug(.*)*",
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___sv_SE",
    path: "/sv_SE/:slug(.*)*",
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___da_DK",
    path: "/da_DK/:slug(.*)*",
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___nl_NL",
    path: "/nl_NL/:slug(.*)*",
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___en_INT",
    path: "/en_INT/:slug(.*)*",
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "account___de_AT",
    path: "/de_AT/account",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/usr/src/app/pages/account/index.vue")
  },
  {
    name: "account___de_DE",
    path: "/de_DE/account",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/usr/src/app/pages/account/index.vue")
  },
  {
    name: "account___de_CH",
    path: "/de_CH/account",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/usr/src/app/pages/account/index.vue")
  },
  {
    name: "account___fr_CH",
    path: "/fr_CH/account",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/usr/src/app/pages/account/index.vue")
  },
  {
    name: "account___en_GB",
    path: "/en_GB/account",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/usr/src/app/pages/account/index.vue")
  },
  {
    name: "account___en_US",
    path: "/en_US/account",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/usr/src/app/pages/account/index.vue")
  },
  {
    name: "account___fr_FR",
    path: "/fr_FR/account",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/usr/src/app/pages/account/index.vue")
  },
  {
    name: "account___sv_SE",
    path: "/sv_SE/account",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/usr/src/app/pages/account/index.vue")
  },
  {
    name: "account___da_DK",
    path: "/da_DK/account",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/usr/src/app/pages/account/index.vue")
  },
  {
    name: "account___nl_NL",
    path: "/nl_NL/account",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/usr/src/app/pages/account/index.vue")
  },
  {
    name: "account___en_INT",
    path: "/en_INT/account",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/usr/src/app/pages/account/index.vue")
  },
  {
    name: "cart-slug___de_AT",
    path: "/de_AT/cart/:slug(.*)*",
    component: () => import("/usr/src/app/pages/cart/[...slug].vue")
  },
  {
    name: "cart-slug___de_DE",
    path: "/de_DE/cart/:slug(.*)*",
    component: () => import("/usr/src/app/pages/cart/[...slug].vue")
  },
  {
    name: "cart-slug___de_CH",
    path: "/de_CH/cart/:slug(.*)*",
    component: () => import("/usr/src/app/pages/cart/[...slug].vue")
  },
  {
    name: "cart-slug___fr_CH",
    path: "/fr_CH/cart/:slug(.*)*",
    component: () => import("/usr/src/app/pages/cart/[...slug].vue")
  },
  {
    name: "cart-slug___en_GB",
    path: "/en_GB/cart/:slug(.*)*",
    component: () => import("/usr/src/app/pages/cart/[...slug].vue")
  },
  {
    name: "cart-slug___en_US",
    path: "/en_US/cart/:slug(.*)*",
    component: () => import("/usr/src/app/pages/cart/[...slug].vue")
  },
  {
    name: "cart-slug___fr_FR",
    path: "/fr_FR/cart/:slug(.*)*",
    component: () => import("/usr/src/app/pages/cart/[...slug].vue")
  },
  {
    name: "cart-slug___sv_SE",
    path: "/sv_SE/cart/:slug(.*)*",
    component: () => import("/usr/src/app/pages/cart/[...slug].vue")
  },
  {
    name: "cart-slug___da_DK",
    path: "/da_DK/cart/:slug(.*)*",
    component: () => import("/usr/src/app/pages/cart/[...slug].vue")
  },
  {
    name: "cart-slug___nl_NL",
    path: "/nl_NL/cart/:slug(.*)*",
    component: () => import("/usr/src/app/pages/cart/[...slug].vue")
  },
  {
    name: "cart-slug___en_INT",
    path: "/en_INT/cart/:slug(.*)*",
    component: () => import("/usr/src/app/pages/cart/[...slug].vue")
  },
  {
    name: component_45stubLq50MOh9E_xuYW_z4dLccAG_41XK6rav1SlBAZqsQOsMeta?.name,
    path: "/de_AT/sitemap.xml",
    component: component_45stubLq50MOh9E_xuYW_z4dLccAG_41XK6rav1SlBAZqsQOs
  },
  {
    name: component_45stubLq50MOh9E_xuYW_z4dLccAG_41XK6rav1SlBAZqsQOsMeta?.name,
    path: "/de_DE/sitemap.xml",
    component: component_45stubLq50MOh9E_xuYW_z4dLccAG_41XK6rav1SlBAZqsQOs
  },
  {
    name: component_45stubLq50MOh9E_xuYW_z4dLccAG_41XK6rav1SlBAZqsQOsMeta?.name,
    path: "/de_CH/sitemap.xml",
    component: component_45stubLq50MOh9E_xuYW_z4dLccAG_41XK6rav1SlBAZqsQOs
  },
  {
    name: component_45stubLq50MOh9E_xuYW_z4dLccAG_41XK6rav1SlBAZqsQOsMeta?.name,
    path: "/fr_CH/sitemap.xml",
    component: component_45stubLq50MOh9E_xuYW_z4dLccAG_41XK6rav1SlBAZqsQOs
  },
  {
    name: component_45stubLq50MOh9E_xuYW_z4dLccAG_41XK6rav1SlBAZqsQOsMeta?.name,
    path: "/en_GB/sitemap.xml",
    component: component_45stubLq50MOh9E_xuYW_z4dLccAG_41XK6rav1SlBAZqsQOs
  },
  {
    name: component_45stubLq50MOh9E_xuYW_z4dLccAG_41XK6rav1SlBAZqsQOsMeta?.name,
    path: "/en_US/sitemap.xml",
    component: component_45stubLq50MOh9E_xuYW_z4dLccAG_41XK6rav1SlBAZqsQOs
  },
  {
    name: component_45stubLq50MOh9E_xuYW_z4dLccAG_41XK6rav1SlBAZqsQOsMeta?.name,
    path: "/fr_FR/sitemap.xml",
    component: component_45stubLq50MOh9E_xuYW_z4dLccAG_41XK6rav1SlBAZqsQOs
  },
  {
    name: component_45stubLq50MOh9E_xuYW_z4dLccAG_41XK6rav1SlBAZqsQOsMeta?.name,
    path: "/sv_SE/sitemap.xml",
    component: component_45stubLq50MOh9E_xuYW_z4dLccAG_41XK6rav1SlBAZqsQOs
  },
  {
    name: component_45stubLq50MOh9E_xuYW_z4dLccAG_41XK6rav1SlBAZqsQOsMeta?.name,
    path: "/da_DK/sitemap.xml",
    component: component_45stubLq50MOh9E_xuYW_z4dLccAG_41XK6rav1SlBAZqsQOs
  },
  {
    name: component_45stubLq50MOh9E_xuYW_z4dLccAG_41XK6rav1SlBAZqsQOsMeta?.name,
    path: "/nl_NL/sitemap.xml",
    component: component_45stubLq50MOh9E_xuYW_z4dLccAG_41XK6rav1SlBAZqsQOs
  },
  {
    name: component_45stubLq50MOh9E_xuYW_z4dLccAG_41XK6rav1SlBAZqsQOsMeta?.name,
    path: "/en_INT/sitemap.xml",
    component: component_45stubLq50MOh9E_xuYW_z4dLccAG_41XK6rav1SlBAZqsQOs
  }
]